import React, {useContext} from 'react';
import {Controller, useFormContext, useWatch} from 'react-hook-form';
import {FormDataProviderAPIContext} from '../../../../../../src/contexts/FormDataProviderAPIContext';
import Translate from '../../../../../../src/components/Translate/Translate';
import CustomSelect from '../../../../../../src/components/Fields/CustomSelect';
import {FormFieldConfigSize} from '../../../../../../src/@types/components/Form';
import classnames from '../../../../../../src/helpers/classnames';
import FormErrorMessage from '../../../../../../src/components/Form/FormErrorMessage';

export default function StatusField({formId, isDisabled}: {
    formId: string,
    isDisabled?: boolean,
}) {
    const {control} = useFormContext();
    const {modelOptions} = useContext(FormDataProviderAPIContext) ?? {};
    const target = useWatch({control, name: 'payload.target'});

    const options = (() => {
        if (target === 'order') {
            return modelOptions?.status;
        } else if (target === 'order-product') {
            return modelOptions?.productStatuses;
        }

        return null;
    })();

    return <Controller
            name="payload.status_id"
            control={control}
            render={(
                    {
                        field: {name, value, onChange, onBlur},
                        fieldState: {error}
                    }
            ) => {
                return <>
                    <Translate<HTMLLabelElement>
                            message="TaskForm.change-status.fields.status_id"
                            tag="label"
                            className="col-form-label-sm col-form-label"
                    />

                    <CustomSelect
                            label="TaskForm.change-status.fields.status_id"
                            size={FormFieldConfigSize.SM}
                            className={classnames({'is-invalid': error})}
                            isInvalid={Boolean(error)}
                            name={name}
                            value={value ? Number(value) : undefined}
                            disabled={isDisabled || !options}
                            options={options ?? []}
                            onChange={onChange}
                            onBlur={onBlur}
                            formId={formId}
                            menuPortalTarget={document.body}
                    />

                    <FormErrorMessage fieldName="payload.status_id"/>
                </>;
            }}
    />;
}
